import { PjmLocationDto } from 'src/domain/pjm/dto/PjmLocationDto';

export enum PjmLocationsModal {
    CREATE = 'create',
    EDIT = 'edit',
    IMPORT = 'import',
    BULK_UPDATE = 'bulk_update',
    AUDIT = 'audit',
}

export interface ModalState {
    modal?: PjmLocationsModal;
    target?: PjmLocationDto;
}

interface EditAction {
    type: 'EDIT';
    payload: PjmLocationDto;
}

interface CreateAction {
    type: 'CREATE';
}

interface ImportAction {
    type: 'IMPORT';
}

interface BulkUpdateAction {
    type: 'BULK_UPDATE';
}

interface AuditAction {
    type: 'AUDIT';
    payload: PjmLocationDto;
}

interface CloseAction {
    type: 'CLOSE';
}

type ModalStateAction = EditAction | CreateAction | ImportAction | BulkUpdateAction | AuditAction | CloseAction;

export function reducer(state: ModalState, action: ModalStateAction): ModalState {
    switch (action.type) {
        case 'EDIT':
            return {
                modal: PjmLocationsModal.EDIT,
                target: action.payload,
            };
        case 'CREATE':
            return {
                modal: PjmLocationsModal.CREATE,
            };
        case 'IMPORT':
            return {
                modal: PjmLocationsModal.IMPORT,
            };
        case 'BULK_UPDATE':
            return {
                modal: PjmLocationsModal.BULK_UPDATE,
            };
        case 'AUDIT':
            return {
                modal: PjmLocationsModal.AUDIT,
                target: action.payload,
            };
        case 'CLOSE':
            return {
                modal: undefined,
            };
        default:
            return state;
    }
}
